/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Styled components for RangeMonthPicker
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

interface IRangeMonthYearPicker {
    isEnabled: boolean;
}

export const RangeMonthPickerStyled = styled.div.attrs({
    'data-name': 'rangeMonthPickerContent',
})`
    ${fonts.textSmall};

    hr {
        border: none;
        border-bottom: 1px solid ${colors.rangePickerHeaderBorderColor};
        margin: 16px 0;
    }
`;

export const RangeMonthPickerRowStyled = styled.div``;

export const RangeMonthPickerRowsContainerStyled = styled.div`
    ${RangeMonthPickerRowStyled}:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const RangeMonthPickerItemStyled = styled.div`
    display: inline-block;
    width: 80px;
    padding: 0 4px;
    box-sizing: content-box;

    div {
        padding: 4px 0;
        border-radius: 16px;
        cursor: pointer;
        line-height: 24px;
        text-align: center;
        color: ${colors.rangePickerItemColor};
    }

    &.date-picker-item--in-range {
        background-color: ${colors.rangePickerItemInRangeBgColor};
        color: ${colors.rangePickerItemInRangeColor};

        &.date-picker-item--range-start {
            margin-left: 4px;
            padding-left: 0;
            border-radius: 16px 0 0 16px;
            background: linear-gradient(to right,
            ${colors.ClearWhite} 50%,
            ${colors.rangePickerItemInRangeBgColor} 50%);
        }
        &.date-picker-item--range-end {
            margin-right: 4px;
            padding-right: 0;
            border-radius: 0 16px 16px 0;
            background: linear-gradient(to left,
            ${colors.ClearWhite} 50%,
            ${colors.rangePickerItemInRangeBgColor} 50%);
        }

        &.date-picker-item--range-start.date-picker-item--range-end {
            background: none;
        }
    }

    &.date-picker-item--in-range,
    &.date-picker-item--in-range.date-picker-item--range-start,
    &.date-picker-item--in-range.date-picker-item--range-end {
        &:first-child {
            margin-left: 4px;
            padding-left: 0;
        }
        &:last-child {
            margin-right: 4px;
            padding-right: 0;
        }
    }

    &:hover {
        div {
            background-color: ${colors.rangePickerItemHoverBgColor};
            color: ${colors.rangePickerItemHoverColor};
        }
    }

    &.date-picker-item--range-start,
    &.date-picker-item--range-end {
        div {
            background-color: ${colors.rangePickerItemSelectedBgColor};
            color: ${colors.rangePickerItemSelectedColor};
        }
    }

    &.date-picker-item--disabled {
        div {
            background-color: ${colors.rangePickerItemDisabledBgColor};
            color: ${colors.rangePickerItemDisabledColor};
            cursor: default;
        }
    }

`;
export const RangeMonthPickerHeaderStyled = styled.div`
    margin-bottom: 16px;
    box-sizing: border-box;

    .select-container {
        border: ${colors.rangePickerHeaderBorderColor} 1px solid;
    }
`;
export const RangeMonthPickerYearSelectStyled = styled.div`
    flex: 1 0 auto;
`;

export const RangeMonthPickerYearSelectLeftStyled = styled.div<IRangeMonthYearPicker>`
    min-width: 20px;
    padding: 5px;
    border-top: ${colors.rangePickerHeaderBorderColor} 1px solid;
    border-bottom: ${colors.rangePickerHeaderBorderColor} 1px solid;
    border-left: ${colors.rangePickerHeaderBorderColor} 1px solid;
    ${props => props.isEnabled ? 'cursor: pointer' : ''};
`;

export const RangeMonthPickerYearSelectRightStyled = styled.div<IRangeMonthYearPicker>`
    min-width: 20px;
    padding: 5px;
    border-top: ${colors.rangePickerHeaderBorderColor} 1px solid;
    border-bottom: ${colors.rangePickerHeaderBorderColor} 1px solid;
    border-right: ${colors.rangePickerHeaderBorderColor} 1px solid;
    ${props => props.isEnabled ? 'cursor: pointer' : ''};
`;

export const RangeMonthPickerLinkStyled = styled.span`
    display: inline-block;
    color: ${colors.rangePickerLinkColor};
    border-bottom: 1px dashed ${colors.rangePickerLinkColor};
    cursor: pointer;
`;
